const enLocale = {
	title: 'Lavu 4 is Live',
	subtitle:
		'Control Panel has new features that will enhance your restaurant management experience.',
	dashboard: 'Dashboard',
	dashboardDesc: 'See all of your organization’s Sales and Labor.',
	endOfDay: 'End of Day',
	endOfDayDesc: 'Track daily information and see your end of day summaries.',
	workforce: 'Workforce',
	workforceDesc:
		'Manage staff and scheduling to fit how your organization operates.',
	transactions: 'Transactions',
	transactionsDesc: 'Check and review any payment or order transactions.',
	seeLater: 'See Later',
	seeLavu4: 'See Lavu 4',
};

export default enLocale;
